import { RegistrationResponse } from '@/modules/onboarding/registration/store/registrationStore';

export type DocumentType = 'emiratesIdFront' | 'emiratesIdBack' | 'passport';
export type ApiDocumentType = 'EID_FRONT' | 'EID_BACK' | 'PASSPORT';

export interface DocumentTypeMapping {
    apiType: ApiDocumentType;
    apiDocType: string; // The doc_type string from API response
}

const DOCUMENT_TYPE_MAP: Record<DocumentType, DocumentTypeMapping> = {
    emiratesIdFront: { apiType: 'EID_FRONT', apiDocType: 'Emirates ID Front' },
    emiratesIdBack: { apiType: 'EID_BACK', apiDocType: 'Emirates ID Back' },
    passport: { apiType: 'PASSPORT', apiDocType: 'Passport' },
};

/**
 * Get API document type from local document type
 */
export function getApiDocumentType(localType: DocumentType): ApiDocumentType {
    return DOCUMENT_TYPE_MAP[localType].apiType;
}

/**
 * Get local document type from API document type
 */
export function getLocalDocumentType(apiType: string): DocumentType | null {
    const entry = Object.entries(DOCUMENT_TYPE_MAP).find(
        ([, mapping]) => mapping.apiType === apiType
    );
    return entry ? (entry[0] as DocumentType) : null;
}

/**
 * Get doc_id from registration response for a given document type
 */
export function getDocIdFromRegistrationResponse(
    documentType: DocumentType,
    registrationResponse: RegistrationResponse | null
): string | null {
    if (!registrationResponse?.documents) {
        return null;
    }

    const apiDocType = DOCUMENT_TYPE_MAP[documentType].apiDocType;
    const document = registrationResponse.documents.find(
        (doc) => doc.doc_type === apiDocType
    );

    return document?.doc_id || null;
}

/**
 * Generate file name for document upload
 * Format: {api-type}-{timestamp}.jpg
 * Examples: "eid-front-1234567890.jpg", "eid-back-1234567890.jpg", "passport-1234567890.jpg"
 */
export function generateDocumentFileName(documentType: DocumentType): string {
    const apiType = DOCUMENT_TYPE_MAP[documentType].apiType;
    const fileName = `${apiType.toLowerCase().replace('_', '-')}-${Date.now()}.jpg`;
    return fileName;
}

